<template>
  <div>
    <span v-html="errorNotFoundBasic"></span>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label> {{ trans('providerController.picture') }} </label>
          <div class="div-profile-picture" v-if="picture_url && !basicModel.picture">
            <img class="profile-picture" :src="picture_url"/>
          </div>
          <VueFileAgent
            ref="vueFileAgent"
            :theme="'list'"
            :multiple="false"
            :deletable="true"
            :meta="true"
            :accept="'image/*'"
            :helpText="trans('providerController.help_type')"
            :errorText="{
              type: 'Invalid file type. Only images Allowed',
            }"
            v-model="basicModel.picture"
          ></VueFileAgent>
          <button
              v-show="this.basicModel.picture"
              @click="() => { this.basicModel.picture = null}"
              class="btn btn-outline-red mt-1"
          >
            {{ trans('providerController.remove_image') }}
          </button>
          <span v-html="errorNotFoundPicture"></span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-xs-12">
        <div class="form-group">
          <label for="first_name">{{trans('providerController.first_name')}}</label>
          <div class="input-group">
            <input
              :disabled="isApproved"
              type="text"
              ref="first_name"
              name="first_name"
              data-test="first_name"
              class="form-control"
              maxlength="30"
              :placeholder="'*' + trans('providerController.first_name') "
              v-model="basicModel.first_name"
              autofocus
            />
            <div class="input-group-addon" ref="first_name_icon">
              <font-awesome-icon icon="user" />
            </div>
          </div>
          <span v-html="errorNotFoundFirstName"></span>
        </div>
      </div>
      <div class="col-md-6 col-xs-12">
        <div class="form-group">
          <label for="last_name">{{ trans('providerController.last_name') }}</label>
          <div class="input-group">
            <input
              :disabled="isApproved"
              type="text"
              ref="last_name"
              name="last_name"
              data-test="last_name"
              class="form-control"
              maxlength="30"
              :placeholder="'*' + trans('providerController.last_name') "
              v-model="basicModel.last_name"
            />
            <div class="input-group-addon" ref="last_name_icon">
              <font-awesome-icon icon="user" />
            </div>
          </div>
          <span v-html="errorNotFoundLastName"></span>
        </div>
      </div>
    </div>
    <div class="row" v-if="!hideInstitution">
      <div class="col-md-7">
        <div class="form-group" name="institution" id="institution">
          <label for="institution">{{ trans('providerController.institution') }}</label>
          <multiselect
            v-if="institution_id == 0"
            v-model="basicModel.institution_id"
            :placeholder="trans('providerController.institution_placeholder')"
            :select-label="trans('providerController.select_institution_label')"
            :selected-label="trans('providerController.selected_institution_label')"
            :deselect-label="trans('providerController.deselected_institution_label')"
            label="social_reason"
            track-by="id"
            :close-on-select="true"
            :options="institutions"
            :multiple="true"
            :show-no-options="false"
            :show-no-results="false"
            data-test="select_institution"
          />
          <select
            v-if="institution_id != 0"
            :disabled="institution_id != 0"
            v-model="institution_id"
            class="form-control"
            name="institutionId"
            data-test="select_institution"
            id="institutionId"
          >
            <option
              v-for="institution in institutions"
              :key="institution.id"
              :value="institution.id"
            >
              {{ institution.social_reason }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>{{ trans('providerController.birthdate') }}</label>
          <div class="input-group">
            <DatePicker
              :disabled="isApproved"
              v-model="basicModel.birthday"
              :lang="lang"
              format="DD/MM/YYYY"
              placeholder="DD/MM/YYYY"
              valueType="DD/MM/YYYY"
              ref="birthday"
              data-test="birthday"
              name="birthday"
            />
          </div>
          <span v-html="errorNotFoundBirthday"></span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group has-feedback">
          <label for="email">{{ trans('providerController.email') }}</label>
          <div class="input-group">
            <input
              :disabled="isApproved"
              type="email"
              ref="email"
              name="email"
              data-test="email"
              maxlength="60"
              class="form-control"
              @change="onChangeEmail(basicModel.email)"
              :placeholder="'*' + trans('providerController.email')"
              v-model="basicModel.email"
            />
            <div class="input-group-addon" ref="email_icon">
              <span class="fa fa-envelope-o"></span>
            </div>
          </div>
          <span v-html="errorNotFoundEmail"></span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="document_individual">{{ trans('providerController.cpf') }}</label>
          <div class="input-group">

            <input
                v-if="cpfMask"
              :disabled="isApproved"
              v-mask="cpfMask"
              type="tel"
              class="form-control cpf"
              name="document_individual"
              data-test="document_individual"
              ref="document_individual"
              @change="onChangeCpf(basicModel.document)"
              :placeholder="trans('providerController.cpf')"
              v-model="basicModel.document"
            />
            <input
                v-else
              :disabled="isApproved"
              type="tel"
              class="form-control cpf"
              name="document_individual"
              data-test="document_individual"
              ref="document_individual"
              @change="onChangeCpf(basicModel.document)"
              :placeholder="trans('providerController.cpf')"
              v-model="basicModel.document"
            />
            <div class="input-group-addon" ref="document_individual_icon">
              <font-awesome-icon icon="user" />
            </div>
          </div>
          <span v-if="lang == 'pt-br'" v-html="errorNotFoundCPF"></span>
          <span v-else></span>
        </div>
      </div>
    </div>
    <div class="row" v-show="showPassword">
      <div class="col-md-6">
        <div class="form-group has-feedback">
          <label for="password">{{ trans('providerController.password') }}</label>
          <div class="input-group">
            <input
              type="password"
              ref="password"
              name="password"
              data-test="password"
              maxlength="20"
              class="form-control"
              :placeholder="'*' + trans('providerController.password')"
              v-model="basicModel.password"
            />
            <div class="input-group-addon" ref="password_icon">
              <span class="fa fa-lock"></span>
            </div>
          </div>
          <span v-html="errorNotFoundPassword"></span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group has-feedback">
          <label for="confirm_password">{{  trans('providerController.confirm_password') }}</label>
          <div class="input-group">
            <input
              type="password"
              ref="confirm_password"
              name="confirm_password"
              data-test="confirm_password"
              maxlength="20"
              class="form-control"
              :placeholder="'*' + trans('providerController.confirm_password')"
              v-model="basicModel.confirm_password"
            />
            <div class="input-group-addon" ref="confirm_password_icon">
              <span class="fa fa-lock"></span>
            </div>
          </div>
          <span v-html="errorNotFoundConfirmPassword"></span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group has-feedback">
          <label for="phone">{{ trans('providerController.label_phone') }}</label>
          <div class="input-group">
            <input
              type="tel"
              id="phone"
              data-test="phone"
              maxlength="19"
              class="form-control"
              autocomplete="false"
              @change="onChangePhone(basicModel.phone)"
              :placeholder="trans('providerController.label_phone')"
              v-model="basicModel.phone"
              style="width: 100%"
              required
            />
            <input type="hidden" name="phone" id="phone_number" />
            <input
              type="hidden"
              name="phone_valid"
              id="phone_valid"
              value="0"
            />
            <input
              type="text"
              name="valid_phone"
              id="valid_phone"
              value=""
              style="display: none"
              required
              data-error="providerController.invalid_phone_number"
            />
            <div class="input-group-addon">
              <span class="fa fa-phone"></span>
            </div>
          </div>
          <div class="help-block with-errors"></div>
        </div>
      </div>
    </div>

    <div class="row" v-show="isLanguageForProviderEnabled">
      <div class="col-md-12">
        <div>
          <label class="control-label" for="email">
            {{ trans('providerController.enabled_laguages') }}
          </label>

          <div id="div-ms" class="input-group">
            <multiselect
              v-model="selectedLanguage"
              :placeholder="trans('providerController.enabled_laguages_placeholder')"
              :select-label="trans('providerController.enabled_laguages_select_label')"
              :selected-label="trans('providerController.enabled_laguages_selected_label')"
              :deselect-label="trans('providerController.enabled_laguages_deselected_label')"
              label="name"
              track-by="id"
              :close-on-select="false"
              :options="languagesEnabled"
              :multiple="true"
              :show-no-options="false"
              :show-no-results="false"
            >
            </multiselect>
            <div class="input-group-addon">
              <span class="fa fa-language"></span>
            </div>
          </div>

          <div class="help-block with-errors"></div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        <div class="form-group has-feedback">
          <label for="zipcode">{{ trans('providerController.zip_code') }}</label>
          <div class="input-group">
            <input
              v-if="cepRequiredValidationDuringSignup == '1'"
              type="tel"
              v-mask="['#####-###']"
              class="form-control zipcode"
              name="zipcode"
              data-test="zipcode"
              @change="onChangeZipcode(basicModel.zipcode)"
              ref="zipcode"
              maxlength="10"
              :placeholder="trans('providerController.zip_code')"
              v-model="basicModel.zipcode"
            />
            <input
              v-else
              class="form-control zipcode"
              name="zipcode"
              data-test="zipcode"
              @change="onChangeZipcode(basicModel.zipcode)"
              ref="zipcode"
              :placeholder="trans('providerController.zip_code')"
              v-model="basicModel.zipcode"
            />
            <div class="input-group-addon" ref="zipcode_icon">
              <span class="fa fa-map-marker"></span>
            </div>
          </div>
          <span v-html="errorNotFoundZipcode"></span>
        </div>
      </div>
      <div class="col-md-7">
        <div class="form-group">
          <label for="country">{{ trans('providerController.country') }}</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              name="country"
              data-test="country"
              ref="country"
              maxlength="20"
              :placeholder="'*' + trans('providerController.country')"
              v-model="basicModel.country"
            />
            <div class="input-group-addon" ref="country_icon">
              <span class="fa fa-map-marker"></span>
            </div>
          </div>
          <span v-html="errorNotFoundCountry"></span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="form-group">
          <label for="address">{{ trans('providerController.address') }}</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              name="address"
              ref="address"
              maxlength="30"
              :placeholder="trans('providerController.address')"
              v-model="basicModel.address"
            />
            <div class="input-group-addon" ref="address_icon">
              <font-awesome-icon icon="address-card" />
            </div>
          </div>
          <span v-html="errorNotFoundAddress"></span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="adress_number">{{ trans('providerController.number') }}</label>
          <div class="input-group">
            <input
              type="number"
              class="form-control"
              data-test="address_number"
              name="address_number"
              ref="address_number"
              maxlength="20"
              min="0"
             :placeholder="'*' + trans('providerController.number')"
              v-model="basicModel.address_number"
            />
            <div class="input-group-addon" ref="address_number_icon">
              <font-awesome-icon icon="address-card" />
            </div>
          </div>
          <span v-html="errorNotFoundAddressNumber"></span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="address_complements">{{ trans('providerController.address_complements') }}</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              name="address_complements"
              id="address_complements"
              maxlength="100"
              :placeholder="trans('providerController.address_complements')"
              v-model="basicModel.address_complements"
            />
            <div class="input-group-addon">
              <font-awesome-icon icon="address-card" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="address_neighbour">{{ trans('providerController.address_neighbour') }}</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              name="address_neighbour"
              ref="address_neighbour"
              maxlength="30"
              :placeholder="'*' + trans('providerController.address_neighbour')"
              v-model="basicModel.address_neighbour"
            />
            <div class="input-group-addon" ref="address_neighbour_icon">
              <font-awesome-icon icon="address-card" />
            </div>
          </div>
          <span v-html="errorNotFoundAddressNeighbour"></span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-7">
        <div class="form-group">
          <label for="address_city">{{ trans('providerController.address_city') }}</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              name="address_city"
              ref="address_city"
              maxlength="30"
              :placeholder="'*' + trans('providerController.address_city')"
              v-model="basicModel.address_city"
            />
            <div class="input-group-addon" ref="address_city_icon">
              <font-awesome-icon icon="address-card" />
            </div>
          </div>
          <span v-html="errorNotFoundAddressCity"></span>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label for="state">{{ trans('providerController.address_state') }}</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              name="state"
              ref="state"
              maxlength="20"
              :placeholder="trans('providerController.address_state')"
              v-model="basicModel.state"
            />
            <div class="input-group-addon" ref="state_icon">
              <font-awesome-icon icon="address-card" />
            </div>
          </div>
          <span v-html="errorNotFoundState"></span>
        </div>
      </div>
    </div>
    <div class="row">
      <input type="hidden" name="Latitude" id="Latitude" v-model="latitude" />
      <input
        type="hidden"
        name="Longitude"
        id="Longitude"
        v-model="longitude"
      />
      <div class="col-md-7">
        <div class="form-group" name="location" id="location">
          <label for="locationId">{{ trans('providerController.location') }}</label>
          <select
            v-model="basicModel.location_id"
            class="form-control"
            name="locationId"
            id="locationId"
          >
            <option
              v-for="location in locations"
              :key="location.id"
              :value="location.id"
            >
              {{ location.name }}
            </option>
          </select>
          <div class="help-block with-errors"></div>
        </div>
      </div>
      <div class="col-md-5" v-show="showStatus">
        <div class="form-group" name="providerStatus" id="providerStatus">
          <label for="providerStatusId">{{ trans('providerController.status') }}</label>
          <select
            v-model="basicModel.status_id"
            class="form-control"
            name="providerStatusId"
            id="providerStatusId"
          >
            <option
              v-for="status in providerStatus"
              :key="status.id"
              :value="status.id"
            >
              {{ status.name }}
            </option>
          </select>
          <div class="help-block with-errors"></div>
        </div>
      </div>
    </div>

    <div class="row" v-if="show_provider_referral_field">
      <div class="col-md-12">
        <div class="form-group box-style">
          <label>{{ trans('providerController.referral') }}</label>
          <input
            :disabled="!enableReferral"
            type="text"
            name="referral_code"
            class="form-control"
            maxlength="15"
            :placeholder=" trans('providerController.referral_code')"
            value=""
          />
        </div>
      </div>
    </div>

    <div class="row" v-show="showTerms">
      <div class="col-md-12">
        <div class="form-group icheck">
          <label for="accept_terms">
            <input
              type="checkbox"
              data-test="accept_terms"
              name="accept_terms"
              ref="accept_terms"
              required
              v-model="basicModel.accept_terms"
              data-error="providerController.accept_terms"
            />
            {{trans('providerController.read_terms') }}
            <a target="_blank" :href="base_url + '/termsncondition/provider'"
              >{{ trans('providerController.terms') }}*</a
            >
          </label>
          <span v-html="errorNotFoundTerms"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Vuetify from 'vuetify';
import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/pt-br';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/index.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import { faUser, faAddressCard } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faUser, faAddressCard);
import VueTheMask from 'vue-the-mask';
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
import _ from "lodash";

Vue.use(VueFileAgent);
Vue.use(VueTheMask);
Vue.use(Vuetify);

Vue.use(VueFormWizard);

export default {
  components: { Multiselect, DatePicker, FontAwesomeIcon },
  props: {
    model: Object,
    locations: Array,
    institutions: Array,
    picture_url: String,
    base_url: String,
    providerId: Number | String,
    institutionId: Number | String,
    hideInstitution: {
      type: Boolean,
      default: false,
    },
    isLanguageForProviderEnabled: Boolean,
    show_provider_referral_field: Boolean | String,
    languagesEnabled: Array,
    getPhone: Function,
    getCpf: Function,
    getEmail: Function,
    setProviderId: Function,
    providerStatus: Array,
    enableReferral: {
      type: Boolean,
      default: false,
    },
    isApproved: {
      type: Boolean,
      default: false,
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
    showLocation: {
      type: Boolean,
      default: false,
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
    showTerms: {
      type: Boolean,
      default: false,
    },
    cpfMask: Boolean | String,
    cepRequiredValidationDuringSignup: Boolean | String,
  },
  vuetify: new Vuetify(),
  data() {
    return {
      basicModel: {},
      institution_id: 0,
      selectedLocation: null,
      selectedLanguage: null,
      latitude: null,
      longitude: null,
      errorNotFoundBasic: '',
      errorNotFoundPicture: '',
      errorNotFoundFirstName: '',
      errorNotFoundLastName: '',
      errorNotFoundBirthday: '',
      errorNotFoundEmail: '',
      errorNotFoundCPF: '',
      errorNotFoundPassword: '',
      errorNotFoundConfirmPassword: '',
      errorNotFoundZipcode: '',
      errorNotFoundCountry: '',
      errorNotFoundAddress: '',
      errorNotFoundAddressNumber: '',
      errorNotFoundAddressNeighbour: '',
      errorNotFoundAddressCity: '',
      errorNotFoundState: '',
      errorNotFoundTerms: '',
      lang: '',
      profile_picture: null,
    };
  },
  methods: {
    trans(key) {
      return _.get(window.lang, key, key);
    },
    // Tenta obter a localizacao do usuario pelo navegador,
    // E o metodo mais preciso mas depende de aceitacao do usuario
    getLocationByBrowser() {
      var self = this;
      if (!this.showLocation)
        document.getElementById('location').style.display = 'none';
      if (window.navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function success(location) {
            if (location.coords) {
              self.latitude = location.coords.latitude;
              self.longitude = location.coords.longitude;
              document.getElementById('Latitude').value = self.latitude;
              document.getElementById('Longitude').value = self.longitude;
            }
          },
          function fail() {
            self.getLocationByIP();
          },
          {
            timeout: 10000,
          }
        );
      } else {
        this.getLocationByIP();
      }
    },
    // Tenta obter uma localizacao pelo IP do dispositivo
    // utilizando a API em *geoplugin.net*
    getLocationByIP() {
      var url = 'https://ipapi.co/json/';
      var self = this;
      $.get(url).then(
        function success(response) {
          // Se atualiza nosso local se ele for undefined, ou seja, nenhum método
          // funcionou e estamos utilizando um local padrão
          self.latitude = parseFloat(response.latitude);
          self.longitude = parseFloat(response.longitude);
          document.getElementById('Latitude').value = self.latitude;
          document.getElementById('Longitude').value = self.longitude;
        },
        function fail() {
          document.getElementById('location').style.display = 'initial';
          document.getElementById('Latitude').value = 0;
          document.getElementById('Longitude').value = 0;
        }
      );
    },
    updateProvider(id) {
      if (this.setProviderId) {
        this.setProviderId(id);
      }
    },
    onChangePhone(phone) {
      if (this.getPhone) {
        this.getPhone(phone);
      }
    },
    onChangeEmail(email) {
      if (this.getEmail) {
        this.getEmail(email);
      }
    },
    onChangeZipcode(zipcode) {
      var self = this;
      axios
        .get(
          this.base_url +
            '/api/v2/provider/wizard/zip_code/' +
            zipcode.replace(/\D/g, ''),
          {
            crossDomain: true,
          }
        )
        .then((response) => {
          if (response.data.success) {
            var data = response.data;
            self.basicModel.address = data.street;
            self.basicModel.address_complements = data.complement;
            self.basicModel.address_neighbour = data.district;
            self.basicModel.address_city = data.city;
            self.basicModel.state = data.state;
            self.basicModel.country = "Brasil";
          }
        })
        .catch((error) => {
          // handle error
        });
    },
    setPicture() {
      if (this.picture_url) {
        this.basicModel.picture = null;
      }
    },
    onChangeCpf(cpf) {
      if (this.getCpf) {
        this.getCpf(cpf);
      }
    },
    validate() {
      var valid = true;

      this.errorNotFoundBasic = '';
      this.errorNotFoundPicture = '';

      if (this.$refs.vueFileAgent.fileRecords.length == 0) {
        if (!this.picture_url) {
          this.errorNotFoundPicture = `<div class="help-block with-errors"><span>' ${this.trans('providerController.picture_file_required')}</span></div>`;

          valid = false;
        }
      } else {
        if (this.basicModel.picture && !this.basicModel.picture.saved_file) {
          this.profile_picture = this.$refs.vueFileAgent.fileRecords[0].file;
        } else {
          this.profile_picture = null;
        }
      }

      if (this.basicModel.first_name.length > 0) {
        this.errorNotFoundFirstName = '';
        this.$refs.first_name.style.border = '1px solid rgb(220, 220, 220)';
        this.$refs.first_name_icon.style.border =
          '1px solid rgb(220, 220, 220)';
      } else {
        this.errorNotFoundFirstName =
          '<div class="help-block with-errors"><span>' + this.trans('provider.firstname_message') + '</span></div>';
        this.$refs.first_name.style.border = '1px solid rgb(169, 68, 66)';
        this.$refs.first_name_icon.style.border = '1px solid rgb(169, 68, 66)';
        valid = false;
      }

      if (this.basicModel.last_name.length > 0) {
        this.errorNotFoundLastName = '';
        this.$refs.last_name.style.border = '1px solid rgb(220, 220, 220)';
        this.$refs.last_name_icon.style.border = '1px solid rgb(220, 220, 220)';
      } else {
        this.errorNotFoundLastName =
          '<div class="help-block with-errors"><span>' + this.trans('provider.lastname_message') + '</span></div>';
        this.$refs.last_name.style.border = '1px solid rgb(169, 68, 66)';
        this.$refs.last_name_icon.style.border = '1px solid rgb(169, 68, 66)';
        valid = false;
      }

      if (this.basicModel.birthday) {
        this.errorNotFoundBirthday = '';
      } else {
        this.errorNotFoundBirthday =
          '<div class="help-block with-errors"><span>' + this.trans('provider.birthday_message') + '</span></div>';
        valid = false;
      }

      if (this.basicModel.email) {
        this.errorNotFoundEmail = '';
        this.$refs.email.style.border = '1px solid rgb(220, 220, 220)';
        this.$refs.email_icon.style.border = '1px solid rgb(220, 220, 220)';
      } else {
        this.errorNotFoundEmail =
          '<div class="help-block with-errors"><span>' + this.trans('provider.email_message') + '</span></div>';
        this.$refs.email.style.border = '1px solid rgb(169, 68, 66)';
        this.$refs.email_icon.style.border = '1px solid rgb(169, 68, 66)';
        valid = false;
      }

      if(this.lang == 'pt-br'){
        if (this.basicModel.document) {
          this.errorNotFoundCPF = '';
          this.$refs.document_individual.style.border =
            '1px solid rgb(220, 220, 220)';
          this.$refs.document_individual_icon.style.border =
            '1px solid rgb(220, 220, 220)';
        } else {
          this.errorNotFoundCPF =
            '<div class="help-block with-errors"><span>' + this.trans('provider.cpf_message') + '</span></div>';
          this.$refs.document_individual.style.border =
            '1px solid rgb(169, 68, 66)';
          this.$refs.document_individual_icon.style.border =
            '1px solid rgb(169, 68, 66)';
          valid = false;
        }
      }

      if (this.basicModel.password || this.providerId) {
        this.errorNotFoundPassword = '';
        this.$refs.password.style.border = '1px solid rgb(220, 220, 220)';
        this.$refs.password_icon.style.border = '1px solid rgb(220, 220, 220)';
      } else {
        this.errorNotFoundPassword =
          '<div class="help-block with-errors"><span>' + this.trans('provider.password_message') + '</span></div>';
        this.$refs.password.style.border = '1px solid rgb(169, 68, 66)';
        this.$refs.password_icon.style.border = '1px solid rgb(169, 68, 66)';
        valid = false;
      }

      if (this.basicModel.confirm_password || this.providerId) {
        this.errorNotFoundConfirmPassword = '';
        this.$refs.confirm_password.style.border =
          '1px solid rgb(220, 220, 220)';
        this.$refs.confirm_password_icon.style.border =
          '1px solid rgb(220, 220, 220)';
      } else {
        this.errorNotFoundConfirmPassword =
          '<div class="help-block with-errors"><span>' + this.trans('provider.confirmpass_message') + '</span></div>';
        this.$refs.confirm_password.style.border = '1px solid rgb(169, 68, 66)';
        this.$refs.confirm_password_icon.style.border =
          '1px solid rgb(169, 68, 66)';
        valid = false;
      }

      if (this.basicModel.confirm_password != this.basicModel.password) {
        this.errorNotFoundConfirmPassword =
          '<div class="help-block with-errors"><span>' + this.trans('provider.confirmpass_error') + '</span></div>';
        this.$refs.confirm_password.style.border = '1px solid rgb(169, 68, 66)';
        this.$refs.confirm_password_icon.style.border =
          '1px solid rgb(169, 68, 66)';
        valid = false;
      }

      if (this.basicModel.zipcode|| !this.cepRequiredValidationDuringSignup) {
        this.errorNotFoundZipcode = '';
        this.$refs.zipcode.style.border = '1px solid rgb(220, 220, 220)';
        this.$refs.zipcode_icon.style.border = '1px solid rgb(220, 220, 220)';
      } else {
        this.errorNotFoundZipcode =
          '<div class="help-block with-errors"><span>' + this.trans('provider.zipcode_message') + '</span></div>';
        this.$refs.zipcode.style.border = '1px solid rgb(169, 68, 66)';
        this.$refs.zipcode_icon.style.border = '1px solid rgb(169, 68, 66)';
        valid = false;
      }

      if (this.basicModel.country) {
        this.errorNotFoundCountry = '';
        this.$refs.country.style.border = '1px solid rgb(220, 220, 220)';
        this.$refs.country_icon.style.border = '1px solid rgb(220, 220, 220)';
      } else {
        this.errorNotFoundCountry =
          '<div class="help-block with-errors"><span>' + this.trans('provider.country_message') + '</span></div>';
        this.$refs.country.style.border = '1px solid rgb(169, 68, 66)';
        this.$refs.country_icon.style.border = '1px solid rgb(169, 68, 66)';
        valid = false;
      }

      if (this.basicModel.address.length > 0) {
        this.errorNotFoundAddress = '';
        this.$refs.address.style.border = '1px solid rgb(220, 220, 220)';
        this.$refs.address_icon.style.border = '1px solid rgb(220, 220, 220)';
      } else {
        this.errorNotFoundAddress =
          '<div class="help-block with-errors"><span>' + this.trans('provider.address_message') + '</span></div>';
        this.$refs.address.style.border = '1px solid rgb(169, 68, 66)';
        this.$refs.address_icon.style.border = '1px solid rgb(169, 68, 66)';
        valid = false;
      }

      if (this.basicModel.address_number) {
        this.errorNotFoundAddressNumber = '';
        this.$refs.address_number.style.border = '1px solid rgb(220, 220, 220)';
        this.$refs.address_number_icon.style.border =
          '1px solid rgb(220, 220, 220)';
      } else {
        this.errorNotFoundAddressNumber =
          '<div class="help-block with-errors"><span>' + this.trans('provider.number_message') + '</span></div>';
        this.$refs.address_number.style.border = '1px solid rgb(169, 68, 66)';
        this.$refs.address_number_icon.style.border =
          '1px solid rgb(169, 68, 66)';
        valid = false;
      }

      if (this.basicModel.address_neighbour.length > 0) {
        this.errorNotFoundAddressNeighbour = '';
        this.$refs.address_neighbour.style.border =
          '1px solid rgb(220, 220, 220)';
        this.$refs.address_neighbour_icon.style.border =
          '1px solid rgb(220, 220, 220)';
      } else {
        this.errorNotFoundAddressNeighbour =
          '<div class="help-block with-errors"><span>' + this.trans('provider.neighbourhood_message') + '</span></div>';
        this.$refs.address_neighbour.style.border =
          '1px solid rgb(169, 68, 66)';
        this.$refs.address_neighbour_icon.style.border =
          '1px solid rgb(169, 68, 66)';
        valid = false;
      }

      if (this.basicModel.address_city.length > 0) {
        this.errorNotFoundAddressCity = '';
        this.$refs.address_city.style.border = '1px solid rgb(220, 220, 220)';
        this.$refs.address_city_icon.style.border =
          '1px solid rgb(220, 220, 220)';
      } else {
        this.errorNotFoundAddressCity =
          '<div class="help-block with-errors"><span>' + this.trans('provider.city_message') + '</span></div>';
        this.$refs.address_city.style.border = '1px solid rgb(169, 68, 66)';
        this.$refs.address_city_icon.style.border =
          '1px solid rgb(169, 68, 66)';
        valid = false;
      }

      if (!this.cepRequiredValidationDuringSignup || this.basicModel.state.length > 0) {
        this.errorNotFoundState = '';
        this.$refs.state.style.border = '1px solid rgb(220, 220, 220)';
        this.$refs.state_icon.style.border = '1px solid rgb(220, 220, 220)';
      } else {
        this.errorNotFoundState =
          '<div class="help-block with-errors"><span>' + this.trans('provider.state_message') + '</span></div>';
        this.$refs.state.style.border = '1px solid rgb(169, 68, 66)';
        this.$refs.state_icon.style.border = '1px solid rgb(169, 68, 66)';
        valid = false;
      }

      if (this.basicModel.accept_terms || !this.showTerms) {
        this.errorNotFounTerms = '';
      } else {
        this.errorNotFoundTerms =
          '<div class="help-block with-errors"><span>Leia e aceite os termos de uso para concluir o cadastro.</span></div>';
        valid = false;
      }

      // return valid;
      return true;
    },
    async save() {
      Swal.fire({
        text: 'Salvando dados básicos...',
      });
      Swal.showLoading();
      
      var institutionIdArray = null;
      if (this.institution_id != 0) {
        institutionIdArray = [this.institution_id];
      } else if (this.basicModel.institution_id) {
        institutionIdArray = this.basicModel.institution_id.map(
          (item) => item.id
        );
      }
      
      var formData = new FormData();
      formData.append('origin', 'web');
      formData.append('first_name', this.basicModel.first_name);
      formData.append('last_name', this.basicModel.last_name);
      formData.append('country', this.basicModel.country);
      formData.append('state', this.basicModel.state);
      formData.append('address', this.basicModel.address);
      formData.append('address_city', this.basicModel.address_city);
      formData.append('address_neighbour', this.basicModel.address_neighbour);
      formData.append(
        'address_complements',
        this.basicModel.address_complements
      );
      formData.append('address_number', this.basicModel.address_number);
      formData.append('zipcode', this.basicModel.zipcode);
      formData.append('login_by', 'manual');
      formData.append('email', this.basicModel.email);
      formData.append('phone', this.basicModel.phone);
      formData.append('birthday', this.basicModel.birthday);
      formData.append('document', this.basicModel.document);
      formData.append('institution_id', institutionIdArray);
      if (this.basicModel.password) {
        formData.append('password', this.basicModel.password);
        formData.append('corfirm_password', this.basicModel.corfirm_password);
      }
      if (this.profile_picture) {
        formData.append('picture', this.profile_picture);
      }

      if(this.basicModel.location_id){
        formData.append('location_id', this.basicModel.location_id);
      }

      if (this.latitude && this.longitude) {
        formData.append('latitude', this.latitude);
        formData.append('longitude', this.longitude);
      }

      if (this.providerId) formData.append('provider_id', this.providerId);

      var terms = true;
      if (this.showTerms) {
        terms = this.basicModel.accept_terms;
      }

      formData.append('accept_terms', terms);

      try {
        var json_result = await axios.post(
          this.base_url + '/api/v2/provider/wizard/save_basic_with_institution',
          formData,
          {
            crossDomain: true,
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        if (json_result.data.success == true) {
          this.updateProvider(json_result.data.provider.id);
          Swal.close();
          return true;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: json_result.data.errors,
          });

          return false;
        }
      } catch (error) {
        alert(error);
        Swal.close();
        return false;
      }
    },
  },
  mounted() {
    this.getLocationByBrowser();

    var inputPicture = document.getElementsByClassName('file-input')[0];
    if (inputPicture) {
      inputPicture.setAttribute('data-test', 'picture');
    }
  },
  created() {
    this.basicModel = this.model;
    this.basicModel.password = null;
    this.basicModel.confirm_password = null;
    if (!this.institutionId) this.institution_id = 0;
    else this.institution_id = this.institutionId;
    this.setPicture();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="./register.css"></style>
<style>
@import 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900';
@import 'https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css';
@import 'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css';
</style>
